import { useState } from "react";
import "./Departments.css";

const data = {
  org: "Zilla Parishad Pune",
  title: "Social Welfare Department",
  titleMarathi: "समाज कल्याण विभाग",
  emblem: "🤝",
  intro: `The Social Welfare Department of Maharashtra Government's Social Justice and Special Assistance Division implements various initiatives to ensure equal opportunities and social justice for Scheduled Castes and other underprivileged groups in rural areas. It focuses on education, economic development, and social security. District Councils are required to allocate at least 20% of their income towards welfare schemes for backward classes, implemented and supervised through this department.`,
  stats: [
    { value: "82", label: "Subsidized Hostels" },
    { value: "596", label: "Community Centres Being Upgraded" },
    { value: "9,205", label: "Disability Allowance Beneficiaries" },
    { value: "₹50,000", label: "Inter-Caste Marriage Grant" },
    { value: "₹1,20,000", label: "Housing Scheme Grant" },
    { value: "20%", label: "ZP Income for Backward Class Welfare" },
  ],
  info: [
    { key: "Under Dept.", val: "Social Justice & Special Assistance" },
    { key: "Hostels", val: "82 Operational" },
    { key: "Community Centres", val: "596 (Upgrading)" },
    { key: "Disability Beneficiaries", val: "9,205" },
    { key: "Annual Disability Allowance", val: "₹6,000/year" },
    { key: "Telephone", val: "020-26131774" },
    { key: "Address", val: "District Level Office" },
  ],
  contact: [
    { icon: "📞", label: "020-26131774" },
    { icon: "🏢", label: "District Level Office" },
    { icon: "🏛️", label: "Zilla Parishad Pune" },
  ],
  services: [
    "SC/ST Welfare Schemes",
    "Housing Assistance",
    "Pre-Matric Scholarships",
    "Hostel Management",
    "Inter-Caste Marriage Grant",
    "Disability Allowance",
    "Earn & Learn Scheme",
    "Community Centre Upgrades",
  ],
  schemes: [
    {
      name: "Development of SC & Neo-Buddhist Settlements",
      desc: "Basic amenities provided in Scheduled Caste and Neo-Buddhist localities including water supply, internal roads, drainage, paved blocks, streetlights, and community halls.",
      amount: "₹4 Lakh – ₹40 Lakh (based on population)",
      icon: "🏘️",
    },
    {
      name: "Inter-Caste Marriage Incentive Grant",
      desc: "Promotes social unity by incentivizing marriages between SC/ST/Vimukta Jati/Nomadic Tribes and upper-caste communities. Marriages between different SC/ST subgroups also eligible.",
      amount: "₹50,000 per couple",
      icon: "💍",
    },
    {
      name: "Subsidized Hostels for Backward Classes",
      desc: "Provides accommodation, food, and basic amenities to economically weaker students from SC, ST, OBC, Vimukta Jati, Nomadic and Special Backward Classes. 82 hostels operational under Pune ZP.",
      amount: "82 Hostels | Grades 5–Higher Education",
      icon: "🏠",
    },
    {
      name: "Pre-Matric Scholarship Scheme",
      desc: "Financial assistance to SC, ST, OBC, Vimukta Jati and Special Backward Class students in Grades 5–10. Includes Savitribai Phule Scholarship, GoI Pre-Matric Scholarship, children of parents in unclean occupations, educational fee assistance, and merit-based scholarships.",
      amount: "Direct Bank Transfer | Grades 5–10",
      icon: "📚",
    },
    {
      name: "Earn and Learn Scheme",
      desc: "Funded through 20% Cess Fund. Provides part-time job opportunities at educational institutions or other locations to financially weaker students. Promotes self-reliance, skill development and reduces dropout rates.",
      amount: "20% Cess Fund",
      icon: "💼",
    },
    {
      name: "Internship Program for BBA Students (MKCL)",
      desc: "BBA students enrolled through MKCL are appointed as interns in various ZP departments to gain hands-on experience in administrative work.",
      amount: "₹12,000 – ₹14,000/month stipend",
      icon: "🎓",
    },
    {
      name: "Divyang Housing Scheme",
      desc: "Provides secure, dignified housing to economically weaker and homeless individuals with disabilities. Focuses on social/economic empowerment, self-reliance, and rehabilitation for independent living.",
      amount: "₹1,20,000 incentive grant",
      icon: "♿",
    },
    {
      name: "Yashwant Housing Scheme",
      desc: "Supports SC, ST, Vimukta Jati and Nomadic Tribe beneficiaries with safe, stable housing. Aims to promote social upliftment, poverty eradication, and improved quality of life with basic amenities.",
      amount: "₹1,20,000 incentive grant",
      icon: "🏡",
    },
    {
      name: "Community Centres to Knowledge Hubs Initiative",
      desc: "Develops community centres in rural areas into knowledge hubs with libraries, study rooms, digital learning facilities, and skill development training. 596 centres under Pune ZP being upgraded with uniform renovations, computers and library resources.",
      amount: "596 Centres | Libraries + Computers",
      icon: "📖",
    },
    {
      name: "Livelihood Allowance for Severely Disabled Individuals",
      desc: "Monthly financial assistance to individuals with more than 60% disability to overcome economic instability and meet basic, medical and daily expenses. 9,205 eligible beneficiaries in Pune ZP.",
      amount: "₹6,000/year | 9,205 Beneficiaries",
      icon: "🫶",
    },
  ],
  tabs: ["Overview", "Schemes", "Services", "Contact"],
};

export default function SocialWelfareVibhag() {
  const [activeTab, setActiveTab] = useState("Overview");

  return (
    <div>
      {/* Top Strip */}
      <div className="dept-top-strip">
        <span>🤝 Zilla Parishad Pune — Social Welfare Department</span>
        <span>📞 020-26131774</span>
      </div>

      {/* Header */}
      <div className="dept-header">
        <div className="dept-header-emblem">{data.emblem}</div>
        <div className="dept-header-text">
          <div className="dept-header-org">{data.org}</div>
          <div className="dept-header-title">{data.title}</div>
          <div className="dept-header-subtitle">{data.titleMarathi}</div>
        </div>
        <div className="dept-header-badge">Social Justice & Special Assistance</div>
      </div>

      {/* Nav Tabs */}
      <div className="dept-nav">
        {data.tabs.map((tab) => (
          <button
            key={tab}
            className={`dept-nav-tab ${activeTab === tab ? "active" : ""}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Main Content */}
      <div className="dept-main">

        {/* Intro Hero */}
        <div className="dept-intro">
          <div className="dept-intro-label">About the Department</div>
          <div className="dept-intro-text">
            {data.intro}
            <br /><br />
            <strong>Key Focus Areas:</strong> Education &nbsp;•&nbsp; Housing &nbsp;•&nbsp; Disability Support &nbsp;•&nbsp; Social Harmony &nbsp;•&nbsp; Skill Development
          </div>
        </div>

        {/* Stats Row */}
        <div className="dept-stats">
          {data.stats.map((s, i) => (
            <div className="dept-stat-card" key={i}>
              <div className="dept-stat-value">{s.value}</div>
              <div className="dept-stat-label">{s.label}</div>
            </div>
          ))}
        </div>

        {/* Schemes Section */}
        <div className="dept-section">
          <div className="dept-section-header">
            <div className="dept-section-icon">📋</div>
            <div className="dept-section-title">Welfare Schemes</div>
          </div>
          <div className="scheme-list">
            {data.schemes.map((scheme, i) => (
              <div className="scheme-card" key={i}>
                <div className="scheme-card-name">
                  <span style={{ marginRight: "8px" }}>{scheme.icon}</span>
                  {scheme.name}
                </div>
                <div className="scheme-card-desc">{scheme.desc}</div>
                <span className="scheme-card-amount">{scheme.amount}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Sidebar */}
        <div className="dept-sidebar">

          {/* Department Info */}
          <div className="dept-info-card">
            <div className="dept-info-card-title">Department Details</div>
            {data.info.map((row, i) => (
              <div className="dept-info-row" key={i}>
                <span className="dept-info-key">{row.key}</span>
                <span className="dept-info-val">{row.val}</span>
              </div>
            ))}
          </div>

          {/* 20% Cess Highlight */}
          <div className="dept-info-card">
            <div className="dept-info-card-title">Funding Mandate</div>
            <div className="dept-highlight-box">
              <div className="dept-highlight-box-title">⚖️ 20% Cess Fund Rule</div>
              <p>
                District Councils are mandated to allocate at least <strong>20% of their income</strong> towards welfare schemes for backward classes. This fund drives most Social Welfare Department schemes.
              </p>
            </div>
          </div>

          {/* RTI Info */}
          <div className="dept-info-card">
            <div className="dept-info-card-title">Transparency</div>
            <div className="dept-highlight-box">
              <div className="dept-highlight-box-title">📜 RTI Act 2005</div>
              <p>
                Information on items 1 to 17 as per Section 4(1)(b) of the Right to Information Act 2005 is available through this department.
              </p>
            </div>
          </div>

          {/* Services */}
          <div className="dept-info-card">
            <div className="dept-info-card-title">Key Services</div>
            <div className="dept-services-grid">
              {data.services.map((s, i) => (
                <div className="dept-service-item" key={i}>{s}</div>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div className="dept-contact-card">
            <div className="dept-contact-card-title">Contact Information</div>
            {data.contact.map((c, i) => (
              <div className="dept-contact-row" key={i}>
                <span>{c.icon}</span>
                <span>{c.label}</span>
              </div>
            ))}
          </div>

        </div>
      </div>

      {/* Footer */}
      <div className="dept-footer">
        <strong>Zilla Parishad Pune</strong> — Social Welfare Department &nbsp;|&nbsp; Telephone: 020-26131774 &nbsp;|&nbsp; District Level Office
      </div>
    </div>
  );
}
